import { render } from "./formations.vue?vue&type=template&id=6e5f9973&scoped=true"
import script from "./formations.vue?vue&type=script&lang=js"
export * from "./formations.vue?vue&type=script&lang=js"

import "./formations.vue?vue&type=style&index=0&id=6e5f9973&lang=css"
import "./formations.vue?vue&type=style&index=1&id=6e5f9973&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e5f9973"]])

export default __exports__